<template>
  <div class="complaint-filter-management">
    <v-container grid-list-xl fluid>
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>Complaint Filter Management</v-toolbar-title>
        </v-toolbar>
        <v-divider></v-divider>
          <v-card-text>
            <div class="card-channel" :style="`borderColor: ${$vuetify.theme.themes.light.primary}`">
              <div class="filter-channel">
                <div class="content">
                  <v-card-title class="card-title">
                    Complaint Filter
                    <a class="material-icons add-filter" @click="addComplaintFilter = !addComplaintFilter" ref="myComplaintFilter">filter_alt
                      <dropdown-menu v-if="addComplaintFilter" @add="addComplaintFilterArr" :someAddId="someAddComplaintFilterId"></dropdown-menu>
                    </a>
                  </v-card-title>
                  <v-progress-linear
                    v-if="progress.complaintFilter"
                    color="primary"
                    indeterminate
                    rounded
                    height="6"
                  ></v-progress-linear>
                  <v-card-text style="padding: 10px;">
                    <vue-perfect-scrollbar style="height: calc(100vh - 350px)">
                      <filter-card
                        v-for="(item,index) in complaintFilterArr"
                        :key="index"
                        :showFilter="item"
                        @deleteCard = "deleteCard"
                        @updateLeadFilterState = "updateLeadFilterState"
                        :ref="`childCardCH${index}`"
                      ></filter-card>
                    </vue-perfect-scrollbar>
                  </v-card-text>
                </div>
              </div>
            </div>
          </v-card-text>
      </v-card>
      <add-error-dialog :showDialog="showDialog" :errorMessage="errorMessage"></add-error-dialog>
      <add-successful-dialog :dialog="showDialog"></add-successful-dialog>
      <v-dialog
        v-model="isUpdating"
        overlay-color="#2296F3"
        overlay-opacity="0.6"
        persistent
        width="300"
      >
        <v-card>
          <v-card-text style="height: 36px !important">
            Please stand by
            <v-progress-linear
              indeterminate
              color="#009688"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import FilterCard from '@/components/panda/setting/FilterCard.vue'
import DropdownMenu from '@/components/panda/setting/DropdownMenu.vue'
import { LFSConfigurationApi } from '@/api/pandaria'
import AddErrorDialog from '@/components/panda/setting/dialog/AddErrorDialog.vue'
import AddSuccessfulDialog from '@/components/panda/setting/dialog/AddSuccessfulDialog.vue'
import { Tool, DataType } from '@/util/index'
const tool = new Tool()
export default {
  name: 'FilterManagement',
  components: {
    FilterCard,
    DropdownMenu,
    AddErrorDialog,
    AddSuccessfulDialog
  },
  data: () => ({
    companyId: 1,
    channelId: -1,
    portfolioId: -1,
    complaintFilterArr: [],
    errorMessage: '',
    states: DataType.states,
    isUpdating: false,
    addComplaintFilter: false,
    someAddComplaintFilterId: {
      companyId: 1,
      channelId: -1,
      portfolioId: -1,
      type: DataType.LeadFilterTypeEnum.COMPLAINT_FILTER.value
    },
    progress: {
      complaintFilter: false
    },
    showDialog: {
      error: false,
      successful: false
    }
  }),
  mounted () {
    document.addEventListener('click', this.bodyCloseMenus)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.bodyCloseMenus)
  },
  methods: {
    bodyCloseMenus (e) {
      const $this = this
      if (this.$refs.myComplaintFilter && !this.$refs.myComplaintFilter.contains(e.target)) {
        if ($this.addComplaintFilter) {
          $this.addComplaintFilter = false
        }
      }
    },
    deleteCard (data) {
      this.complaintFilterArr = this.complaintFilterArr.filter(e => {
        return !(e.channelId === data.channelId && e.companyId === data.companyId && e.operator === data.operator && e.parameterKey === data.parameterKey && e.portfolioId === data.portfolioId && e.sectionKey === data.sectionKey && e.type === data.type)
      })
    },
    updateLeadFilterState (data, before) {
      const $this = this
      let count = 0
      let index = 0
      if ($this.complaintFilterArr.length === 1) {
        $this.isUpdating = true
        LFSConfigurationApi.updateLeadFilterParameter(data, function () {
          $this.complaintFilterArr[0].operator = data.current
          $this.isUpdating = false
          $this.showDialog.successful = true
        })
      } else if ($this.complaintFilterArr.length > 1) {
        $this.complaintFilterArr.forEach(e => {
          if (e.channelId === data.channelId && e.companyId === data.companyId && e.operator === data.current && e.parameterKey === data.parameterKey && e.portfolioId === data.portfolioId && e.sectionKey === data.sectionKey && e.type === data.type) {
            $this.errorMessage = 'Filter for ' + data.sectionKey + '.' + data.parameterKey + ' ' + $this.states.find(e => e.value === data.current).text + ' is existed'
            $this.showDialog.error = true
            count++
          }
        })
        for (let i = 0; i < $this.complaintFilterArr.length; i++) {
          const e = $this.complaintFilterArr[i]
          if (e.channelId === before.channelId && e.companyId === before.companyId && e.operator === before.operator && e.parameterKey === before.parameterKey && e.portfolioId === before.portfolioId && e.sectionKey === before.sectionKey && e.type === before.type) {
            index = i
          }
        }
        if (count === 0) {
          $this.isUpdating = true
          LFSConfigurationApi.updateLeadFilterParameter(data, function () {
            $this.complaintFilterArr[index].operator = data.current
            $this.isUpdating = false
            $this.showDialog.successful = true
          })
        } else {
          $this.$refs[`childCardCH${index}`][0].select_state = $this.states.find(e => e.value === before.operator).text
        }
      }
    },
    addComplaintFilterArr (data) {
      let count = 0
      this.complaintFilterArr.forEach(e => {
        if (e.channelId === data.channelId && e.companyId === data.companyId && e.operator === data.operator && e.parameterKey === data.parameterKey && e.portfolioId === data.portfolioId && e.sectionKey === data.sectionKey && e.type === data.type) {
          this.errorMessage = 'Filter for ' + data.sectionKey + '.' + data.parameterKey + ' ' + this.states.find(e => e.value === data.operator).text + ' is existed'
          this.showDialog.error = true
          count++
        }
      })
      if (count === 0) {
        this.complaintFilterArr.push(data)
      }
    },
    initDisplayComplaintFilter () {
      const $this = this
      $this.progress.complaintFilter = true
      $this.complaintFilterArr = []
      const input = {
        companyId: $this.companyId,
        channelId: $this.channelId,
        portfolioId: $this.portfolioId
      }
      LFSConfigurationApi.displayLeadFilterParameter(input, function (result) {
        $this.progress.complaintFilter = false
        if (tool.isEmpty(result)) {
          result = []
        }
        for (const item of result) {
          if (item.type === DataType.LeadFilterTypeEnum.COMPLAINT_FILTER.value) {
            $this.complaintFilterArr.push(item)
          }
        }
      }, function () {
        $this.progress.complaintFilter = false
      })
    }
  },
  created () {
    this.initDisplayComplaintFilter()
  }
}
</script>

<style scoped>
  .v-card__text {
    width: 100%;
  }
  .tab-content {
    margin: 0;
    padding: 5px;
    width: 100%;
  }
  .card-channel {
    flex: 0 0 100%;
    max-width: 100%;
    background: #fff;
    border: 3px solid;
    border-radius: 5px;
  }
  .filter-channel {
    display: inline-block;
    width: 100%;
  }
  .card-title {
    display: flex;
    justify-content: space-between;
  }
  .v-card__title {
    padding: 10px 10px 0 !important;
  }
  .content {
    border: none;
    margin: 0px 10px 10px;
    height: calc(100vh - 295px);
  }
  .add-filter {
    position: relative;
  }
</style>
